export function baseInputConfig({ colors }) {
    return {
        message: {
            warning: {
                color: colors.variant.warningColorDark
            }
        }
    };
}
